export class NotFoundError extends Error {
  constructor() {
    super("The specified resource could not be found.");
    this.name = "NotFoundError";
  }
}
